import type { AppointmentMode, AppointmentPlatform } from '@performance-crm/shared';

export interface AppointmentForm {
  mode: AppointmentMode;
  platform: AppointmentPlatform | '';
  location: string;
  url: string;
  /** 7.22: asesor de sala que atenderá la cita ('' = el mismo asesor del lead). */
  roomAdvisorId: string;
}

export const emptyAppointment = (): AppointmentForm => ({
  mode: 'PRESENCIAL',
  platform: '',
  location: '',
  url: '',
  roomAdvisorId: '',
});

/** Payload validado por la API a partir del formulario (null si no hay nada que mandar). */
export function toAppointmentDetails(a: AppointmentForm) {
  const roomAdvisorId = a.roomAdvisorId || null;
  return a.mode === 'VIRTUAL'
    ? {
        mode: a.mode,
        platform: a.platform || null,
        location: null,
        url: a.url.trim() || null,
        roomAdvisorId,
      }
    : {
        mode: a.mode,
        platform: null,
        location: a.location.trim() || null,
        url: null,
        roomAdvisorId,
      };
}

/** Lugar sugerido para una cita presencial: la sala de ventas del proyecto. */
export function defaultAppointmentLocation(project?: {
  name: string;
  address?: string | null;
  district?: string | null;
}) {
  if (!project) return '';
  const where = project.address || project.district;
  return `Sala de ventas ${project.name}${where ? ` · ${where}` : ''}`;
}

/** La asistencia se confirma desde la hora programada de la cita; antes, la API responde 400 y la web deshabilita. */
export function appointmentDue(scheduledAt: string | null | undefined, now = Date.now()) {
  return !scheduledAt || new Date(scheduledAt).getTime() <= now;
}
